import AxiosClient from "../../../services/axios.services";

class FactorNameServices {
  getFactorName = (params) =>
    AxiosClient.get("/api/app/descriptor_perfil_factor/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getFactorNameById = (id) =>
    AxiosClient.get(`/api/app/descriptor_perfil_factor/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveFactorName = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_factor/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editFactorName = (id, data) =>
    AxiosClient.put(`/api/app/descriptor_perfil_factor/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteFactorName = (id) =>
    AxiosClient.delete(`/api/app/descriptor_perfil_factor/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new FactorNameServices();
